import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-mfx-message',
  templateUrl: './mfx-message.component.html',
  styleUrls: ['./mfx-message.component.css']
})
export class MfxMessageComponent implements OnInit {

  constructor() { }
  @Input() public label: any;
  @Input() public subLabel: any;
  @Input() public color: any
  @Input() public icon: any;

  public get faIcon() {
    if (!this.icon)
      return 'info-circle';
    return this.icon == "info" ? 'info-circle' : (this.icon == 'error' ? 'exclamation-circle' : 'info-circle');
  }
  ngOnInit(): void {
  }

}
